import React from "react";
import FinalCTA from "../components/FinalCTA";

export default function AboutPage() {
  return (
    <div data-testid="mk-about">
      <section className="mk-section !pb-16 relative overflow-hidden">
        <div className="mk-grid-bg absolute inset-0 opacity-60 pointer-events-none" />
        <div className="mk-container relative z-10 max-w-4xl">
          <div className="mk-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--mk-accent)] mb-4">
            About Fixlr
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mk-display leading-[0.95]">
            Maintenance software<br /> that respects the work.
          </h1>
          <p className="mt-6 text-lg text-[var(--mk-text-dim)] leading-relaxed max-w-3xl">
            Fixlr started as an internal tool for a multi-site facilities operator who was tired of stitching together six disconnected SaaS products. Today it's the multi-tenant platform behind thousands of daily jobs across property managers, FM companies, and field-service crews — with a stubbornly simple principle at its core: the software should make the person on the ground faster, not the person in the office.
          </p>
        </div>
      </section>

      <section className="mk-section">
        <div className="mk-container grid md:grid-cols-3 gap-6">
          {[
            {
              t: "Engineered",
              b: "Every module is tested, audit-logged, and built with real SLA pressure in mind. No vapourware.",
            },
            {
              t: "Opinionated",
              b: "We bake in the playbook that works — briefings, escalation ladders, compliance expiry chains — so you don't have to reinvent ops.",
            },
            {
              t: "Open",
              b: "Webhooks, APIs, data export. We never hold your data hostage.",
            },
          ].map((v) => (
            <div key={v.t} className="rounded-2xl border p-6" style={{ borderColor: "var(--mk-border-subtle)", background: "var(--mk-surface)" }}>
              <div className="mk-mono text-[10px] font-bold uppercase tracking-[0.25em] text-[var(--mk-accent)] mb-2">{v.t}</div>
              <div className="text-sm text-[var(--mk-text-dim)]">{v.b}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mk-section">
        <div className="mk-container max-w-3xl">
          <div className="mk-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--mk-accent)] mb-4">
            Built for operators, by operators
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mk-display mb-6">
            We've been the customer. That's why the product feels different.
          </h2>
          <p className="text-base md:text-lg text-[var(--mk-text-dim)] leading-relaxed">
            Every feature shipped to Fixlr was once a painful Monday-morning admin task for the team that built it. From "where is my operative right now" (→ Live Team Map), to "this supplier's insurance has lapsed and nobody noticed" (→ Supplier Compliance scheduler), to "I need to see the quote, the job, and the invoice in one click" (→ Quote-to-Cash pipeline) — it's software shaped by real pain.
          </p>
        </div>
      </section>

      <FinalCTA headline="See Fixlr on a 20-minute call." sub="We'll migrate a sample of your live data into a sandbox so you can see exactly how your own ops would feel inside Fixlr." />
    </div>
  );
}
